import house_0 from './../images/houses/house-0.jpg';
import house_1 from './../images/houses/house-1.jpg';
import house_2 from './../images/houses/house-2.jpg';
import house_3 from './../images/houses/house-3.jpg';
import house_4 from './../images/houses/house-4.jpg';
import house_5 from './../images/houses/house-5.jpg';
import house_6 from './../images/houses/house-6.jpg';
import house_7 from './../images/houses/house-7.jpg';
import house_8 from './../images/houses/house-8.jpg';
import house_9 from './../images/houses/house-9.jpg';
import house_10 from './../images/house_10.jpg';
import house_11 from './../images/house_11.jpg';
import house_12 from './../images/house_12.jpg';
import house_13 from './../images/house_13.jpg';
import house_14 from './../images/house_14.jpg';
import house_15 from './../images/house_15.jpg';
import house_16 from './../images/house_16.jpg';




import ac from '../images/svg/ac.svg';
import dishwasher from '../images/svg/dishwasher.svg';
import doorman from '../images/svg/doorman.svg';
import elevator from '../images/svg/elevator.svg';
import floor from '../images/svg/floor.svg';
import parking from '../images/svg/parking.svg';
import view from '../images/svg/view.svg';
import storage from '../images/svg/storage.svg';

export const DATA = {

  delhi: [{
      _id: "5e26d7a28a8bcf97a3689140",
      latitude: 28.7036743,
      longitude: 77.1092107,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Pritam Pura, New Delhi, Delhi",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_0

    },
    {
      _id: "5e26d7a28a8bcf97a3689141",
      latitude: 28.64418583,
      longitude: 77.1118574,
      bed_room: 2,
      area: 1000,
      bathroom: 2,
      price: 24000,
      address: "Rajouri Garden, New Delhi, Delhi",
      type: "Apartment",
      amenities: [{
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_1
    },
    {
      _id: "5e26d7a28a8bcf97a3689142",
      latitude: 28.6514509,
      longitude: 77.1083227,
      bed_room: 1,
      area: 720,
      bathroom: 1,
      price: 11000,
      address: "Tagore Garden, New Delhi, Delhi",
      type: "Room",
      amenities: [{
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_2
    },
    {
      _id: "5e26d7a28a8bcf97a3689143",
      latitude: 28.6765576,
      longitude: 77.085389,
      bed_room: 4,
      area: 3052,
      bathroom: 5,
      price: 78000,
      address: "Peera Garhi, New Delhi, Delhi",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_3

    },
    {
      _id: "5e26d7a28a8bcf97a3689144",
      latitude: 28.649759,
      longitude: 77.1255622,
      bed_room: 2,
      area: 3052,
      bathroom: 2,
      price: 12000,
      address: "Ramesh Nagar, New Delhi, Delhi",
      type: "Room",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_4
    }, {
      _id: "5e26d7a28a8bcf97a3689145",
      latitude: 28.6373054,
      longitude: 77.1094577,
      bed_room: 6,
      area: 3052,
      bathroom: 5,
      price: 118000,
      address: "Subhash Nagar, New Delhi, Delhi",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_5
    }
  ],
  agra: [{
      _id: "5e26d7a28a8bcf97a3689150",
      latitude: 27.1743278,
      longitude: 77.9915143,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Pritam Pura, Agra UP India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_6
    },
    {
      _id: "5e26d7a28a8bcf97a3689151",
      latitude: 27.1748054,
      longitude: 77.9921562,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Yogi Nagar, Agra UP India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_7
    },
    {
      _id: "5e26d7a28a8bcf97a3689152",
      latitude: 27.1748437,
      longitude: 77.9924358,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Shayam Nagar, Agra UP India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_8
    },
    {
      _id: "5e26d7a28a8bcf97a3689153",
      latitude: 27.1758957,
      longitude: 77.9926758,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Idgah Colony, Agra UP India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_9
    },
    {
      _id: "5e26d7a28a8bcf97a3689154",
      latitude: 27.1758957,
      longitude: 77.9926758,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Shahganj, Agra UP India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_10
    },
    {
      _id: "5e26d7a28a8bcf97a3689155",
      latitude: 27.1768792,
      longitude: 77.9923181,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Indra Colony, Agra UP India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_11
    }
  ],
  amritsar: [{
      _id: "5e26d7a28a8bcf97a3689160",
      latitude: 31.619196,
      longitude: 74.838183,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Guru Nanak Pura, Amritsar Punjab India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_3
    },
    {
      _id: "5e26d7a28a8bcf97a3689161",
      latitude: 31.639952,
      longitude: 74.830294,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Amritsar Punjab India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_4
    },
    {
      _id: "5e26d7a28a8bcf97a3689162",
      latitude: 31.608651,
      longitude: 74.881773,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Kotatma ram, Amritsar Punjab India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_5
    },
    {
      _id: "5e26d7a28a8bcf97a3689163",
      latitude: 31.616538,
      longitude: 74.890363,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Green, Amritsar Punjab India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_6
    },
    {
      _id: "5e26d7a28a8bcf97a3689164",
      latitude: 31.632030,
      longitude: 74.892095,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Sharifpur, Amritsar Punjab India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_7
    }
  ],
  assam: [{
      _id: "5e26d7a28a8bcf97a3689170",
      latitude: 26.404645,
      longitude: 91.741307,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Kamrup, Assam India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_1
    },
    {
      _id: "5e26d7a28a8bcf97a3689171",
      latitude: 26.400886,
      longitude: 92.466016,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Nagaon, Assam India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_2
    },
    {
      _id: "5e26d7a28a8bcf97a3689172",
      latitude: 26.726127,
      longitude: 92.259333,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Udalgiri, Assam India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_3
    },
    {
      _id: "5e26d7a28a8bcf97a3689173",
      latitude: 26.450428,
      longitude: 93.191818,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Karbi, Assam India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_4
    },
    {
      _id: "5e26d7a28a8bcf97a3689174",
      latitude: 26.595176,
      longitude: 92.308589,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Darrang, Assam India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_5
    },
    {
      _id: "5e26d7a28a8bcf97a3689175",
      latitude: 26.775701,
      longitude: 92.673900,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Sonita, Assam India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_6
    }
  ],
  shimla: [{
      _id: "5e26d7a28a8bcf97a3689180",
      latitude: 31.091512,
      longitude: 77.156168,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Tutikandi, Shimla HP India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_8
    },
    {
      _id: "5e26d7a28a8bcf97a3689181",
      latitude: 31.088030,
      longitude: 77.170061,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Tutikandi, Shimla HP India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_9
    },
    {
      _id: "5e26d7a28a8bcf97a3689182",
      latitude: 31.088030,
      longitude: 77.170061,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Tutikandi, Shimla HP India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_10
    },
    {

      _id: "5e26d7a28a8bcf97a3689183",
      latitude: 31.088030,
      longitude: 77.170061,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Khaliki, Shimla HP India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_1
    },
    {

      _id: "5e26d7a28a8bcf97a3689183",
      latitude: 31.088030,
      longitude: 77.170061,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Khaliki, Shimla HP India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_2
    },
    {

      _id: "5e26d7a28a8bcf97a3689183",
      latitude: 31.088030,
      longitude: 77.170061,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Khaliki, Shimla HP India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_1
    },
    {

      _id: "5e26d7a28a8bcf97a3689183",
      latitude: 31.111492,
      longitude: 77.1052007,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Khaliki, Shimla HP India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_3
    },

    {

      _id: "5e26d7a28a8bcf97a3689184",
      latitude: 31.083685,
      longitude: 77.192607,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Malyana, Shimla HP India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_4
    }

  ],
  patna: [{
      _id: "5e26d7a28a8bcf97a3689190",
      latitude: 25.594085,
      longitude: 85.104241,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Rajbanshi, Bihar India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_12
    },
    {
      _id: "5e26d7a28a8bcf97a3689191",
      latitude: 25.624429,
      longitude: 85.079869,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Janta Vihar, Bihar India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_13
    },
    {
      _id: "5e26d7a28a8bcf97a3689192",
      latitude: 25.601494,
      longitude: 85.158833,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Chitragupta, Bihar India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_14
    },
    {
      _id: "5e26d7a28a8bcf97a3689193",
      latitude: 25.630929,
      longitude: 85.048278,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Danapur, Bihar India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_15
    },
    {
      _id: "5e26d7a28a8bcf97a3689194",
      latitude: 25.626596,
      longitude: 85.085707,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Rajeev Nagar, Bihar India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_16
    },
    {
      _id: "5e26d7a28a8bcf97a3689195",
      latitude: 25.619780,
      longitude: 85.113862,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Rajeev Nagar, Bihar India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_1
    }
  ],
  chandigarh: [{
      _id: "5e26d7a28a8bcf97a3689110",
      latitude: 30.740049,
      longitude: 76.795808,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Sector 8, Chandigarh India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_2
    },
    {
      _id: "5e26d7a28a8bcf97a3689111",
      latitude: 30.721594,
      longitude: 76.811843,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Sector 26 east, Chandigarh India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_3
    },
    {
      _id: "5e26d7a28a8bcf97a3689112",
      latitude: 30.729809,
      longitude: 76.779134,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Sector 21, Chandigarh India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_4
    },
    {
      _id: "5e26d7a28a8bcf97a3689113",
      latitude: 30.745392,
      longitude: 76.729276,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Sector 39, Chandigarh India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_5
    },
    {
      _id: "5e26d7a28a8bcf97a3689114",
      latitude: 30.755476,
      longitude: 76.771850,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Sector 15, Chandigarh India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_6
    },
    {
      _id: "5e26d7a28a8bcf97a3689115",
      latitude: 30.727352,
      longitude: 76.779449,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Sector 21, Chandigarh India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_7
    }
  ],
  gurugram: [{
      _id: "5e26d7a28a8bcf97a3689120",
      latitude: 28.434304,
      longitude: 76.973965,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Sector 36, Gurugram India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_14
    },
    {
      _id: "5e26d7a28a8bcf97a3689121",
      latitude: 28.438483,
      longitude: 77.019307,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Sector 33, Gurugram India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_15
    },
    {
      _id: "5e26d7a28a8bcf97a3689122",
      latitude: 28.457269,
      longitude: 76.953383,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Gopalpur, Gurugram India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_16
    },
    {
      _id: "5e26d7a28a8bcf97a3689123",
      latitude: 28.418030,
      longitude: 76.932743,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Sector 93, Gurugram India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_4
    },
    {
      _id: "5e26d7a28a8bcf97a3689124",
      latitude: 28.459671,
      longitude: 76.971247,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Sector 100, Gurugram India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_5
    },
    {
      _id: "5e26d7a28a8bcf97a3689125",
      latitude: 28.468098,
      longitude: 77.000116,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Surya vihar, Gurugram India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_6
    }
  ],
  ladakh: [{
      _id: "5e26d7a28a8bcf97a3689130",
      latitude: 34.163635,
      longitude: 77.582233,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Fort Rd, Ladakh Leh India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_8
    },
    {
      _id: "5e26d7a28a8bcf97a3689131",
      latitude: 34.164842, 
      longitude: 77.582061,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Malpuk, Ladakh Leh India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_9
    },
    {
      _id: "5e26d7a28a8bcf97a3689132",
      latitude: 34.164105,  
      longitude: 77.583317,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Malpuk, Ladakh Leh India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_10
    },
    {
      _id: "5e26d7a28a8bcf97a3689133",
      latitude: 34.163431,
      longitude:  77.580645,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Guest house, Ladakh Leh India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_11
    },
    {
      _id: "5e26d7a28a8bcf97a3689134",
      latitude: 34.164523, 
      longitude:  77.580710,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Ladakh Leh India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_12
    },
    {
      _id: "5e26d7a28a8bcf97a3689135",
      latitude: 34.164860, 
      longitude: 77.581611,
      bed_room: 2,
      area: 1052,
      bathroom: 2,
      price: 28000,
      address: "Ladakh Leh India",
      type: "Apartment",
      amenities: [{
        svg: elevator,
        text: "elevator"
      }, {
        svg: floor,
        text: "hardwood floor"
      }, {
        svg: parking,
        text: "parking"
      }, {
        svg: view,
        text: "view"
      }, {
        svg: ac,
        text: "Air Conditioner"
      }, {
        svg: dishwasher,
        text: "Dish-Washer"
      }, {
        svg: doorman,
        text: "Doorman"
      }, {
        svg: storage,
        text: "Storage"
      }],
      ownerContactNumber: 9090909090,
      main_img: house_13
    }
  ]

}
// ,